import _ from "lodash";
import WebStoragePolyfill from "../../data-providers/webstorage-polyfill";
import StoreHistory from "../../data-providers/store-history";
import Analytics from "../../analytics";

const perPage = 25;
const categories = ['ALL', 'HOBBIES', 'ANIMALS', 'OCCUPATION', 'SPORTS', 'MILITARY', 'HOLIDAYS', 'BUSINESS', 'OTHER'];

export default [
  '$stateParams', '$sce', '$q', '$scope', 'ClientService', 'CurrencyService', 'ErrorHandler',
  class ClientStoreCtrl {
    constructor($stateParams, $sce, $q, $scope, clientService, CurrencyService, errorHandler, webstorage = new WebStoragePolyfill(), storeHistory = new StoreHistory(), analytics = new Analytics()) {
      this._$stateParams = $stateParams;
      this._$sce = $sce;
      this._$q = $q;
      this._$scope = $scope;
      this._clientService = clientService;
      this._errorHandler = errorHandler;
      this._storage = webstorage;
      this._storeHistory = storeHistory;
      this.analytics = analytics;

      this.clientName = $stateParams.publicName;
      this.storeName = $stateParams.storeName;

      this.currency = CurrencyService;
      this.currency.init();

      this.store = {};
      this.campaigns = {};
      this.categoryCounts = {};
      this.category = categories[0];
      _.forEach(categories, (category) => this.campaigns[category] = []);

      this.firstLoad = true;
      this.loading = false;

      this.storeCoupon = (typeof $stateParams.coupon === 'string' && $stateParams.coupon !== '') ? `?coupon=${$stateParams.coupon}` : '';

      this._getStoreDetails()
        .finally(() => this.firstLoad = false);
    }

    storeDescription() {
      return this._$sce.trustAsHtml(this.store.description);
    }

    categories() {
      return categories;
    }

    nextPage() {
      if (this.lazyLoadDisabled()) return;

      let currentPage = 0;
      if (this.categoryCounts[this.category] > 0) {
        currentPage = (this.campaigns[this.category].length / perPage);
      }

      this._getPage(currentPage)
        .then((res) => {
          this.campaigns[this.category].push(res.results);
          this.campaigns[this.category] = _.flatten(this.campaigns[this.category]);
        });
    }

    lazyLoadDisabled() {
      if (this.loading || this.firstLoad) return true;
      if (this.campaigns[this.category].length >= this.categoryCounts[this.category]) return true;
      return false;
    }

    _getStoreDetails(client, store) {
      let storeInfo, campaigns;

      storeInfo = this._clientService.getStore(this.clientName, this.storeName)
        .then((res) => this._saveStore(res))
        .catch((err) => this._errorHandler.throwError('Store Info Error', err && err.data && err.data.message ? err.data.message : 'Could not load store details, please try again.'));

      campaigns = this._getPage(0);

      return this._$q.all([storeInfo, campaigns])
        .then(res => {
          if (this.store.is_tag_based) {
            this.campaigns.ALL = res[1].results
          } else {
            this.campaigns.ALL = _.sortBy(res[1].results, (result) => parseInt(result.priority));
          }
        })
        .catch(() => {
          this.storeNotFound = true;
          this.loading = false;
        });
    }

    _saveStore(res) {
      this.store = res;

      if (res.status === 'ONLINE') {
        this._storeHistory.setLastStore(res, this.clientName, this.storeName);
        this.analytics.store(res, `${this._$stateParams.publicName}/${this._$stateParams.storeName}`);
      }

      if (res.cobrand_id) {
        this._$scope.$emit('partnership:showLogo', {
          pid: res.cobrand_id
        });
      }
    }

    _getPage(page) {
      this.loading = true;
      let query = {
        from: (page * perPage),
        per_page: perPage
      };

      if (this.category !== categories[0]) {
        query.category = this.category;
      }

      let promise = this._clientService.getCampaignsForStore(this.clientName, this.storeName, query);

      promise
        .then((res) => {
          if (typeof this.categoryCounts[this.category] === 'undefined') {
            this.categoryCounts[this.category] = res.total_hits;
          }
          this.loading = false;
        })
        .catch((err) => this._errorHandler.throwError('Store Campaigns Error', err && err.data && err.data.message ? err.data.message : 'Could not load campaigns belonging to this store, please try again.'));

      return promise;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/client-store/client-store.ctrl.js